// Auto-generated from Matrixify export for AutoGear vehicle finder.
// Source: D:/Downloads/Export_2026-06-25_043956.xlsx
// Products with vehicle data: 480; brands: 15; relations: 506.
window.AutoGearVehicleFinderData = {
  "android-autoradio-navigation": {
    "title": "Autoradio & Navigation",
    "options": [],
    "metafields": [
      "Audi",
      "BMW",
      "Ford",
      "Honda",
      "Hyundai / Kia",
      "Mazda",
      "Mercedes Benz",
      "Peugeot / Citroen / Opel / Fiat / Jeep",
      "Porsche",
      "Renault / Nissan / Dacia",
      "Suzuki",
      "Toyota / Lexus",
      "Universelle Autoradios",
      "VW / Skoda / SEAT",
      "Weitere Marken"
    ],
    "multi_metafields": [
      "1er",
      "2er",
      "3er",
      "4er",
      "5er",
      "6er",
      "7er",
      "370Z Roadster",
      "4007",
      "A-Klasse",
      "Acadia",
      "Accord7 2003-2007 (Benzin)",
      "Alfa Romeo 159",
      "Alfa Romeo 159 Sportwagon",
      "Alfa Romeo Brera",
      "Alfa Romeo Giulietta",
      "Alfa Romeo Spider",
      "Audi A1",
      "Audi A3",
      "Audi A3 (8V)",
      "Audi A4",
      "Audi A4 (8E/8F/B7)",
      "Audi A4 (2000-2009)",
      "Audi A4 (2009-2016)",
      "Audi A4 (B7/8E/8F)",
      "Audi A4 (B8)",
      "Audi A4 B8",
      "Audi A4/S4/RS4 8E/8F/B9/B7",
      "Audi A4L",
      "Audi A4L (2009-2016)",
      "Audi A5",
      "Audi A5 (8T)",
      "Audi A5 (2009-2016)",
      "Audi A6",
      "Audi A6 (2005-2009)",
      "Audi A6 (C7)",
      "Audi A6 C6",
      "Audi A6L",
      "Audi A7",
      "Audi A7 (4G)",
      "Audi Q3",
      "Audi Q5 (2009-2016)",
      "Audi Q5 (Typ 8R)",
      "Audi Q5L",
      "Audi Q7",
      "Audi RS3",
      "Audi RS4 (8E/8F/B7)",
      "Audi RS4 (B7)",
      "Audi S3",
      "Audi S4",
      "Audi S4 (8E/8F/B7)",
      "Audi S4 (2000-2009)",
      "Audi S4 (B7)",
      "Audi S5",
      "Audi TT",
      "Audi TT (2006-2014)",
      "Audi TT (MK2)",
      "Avalanche",
      "B-Klasse",
      "Bipper",
      "Buick Enclave 2007-2012",
      "Buick Regal (2009-2013)",
      "C4 / C4L",
      "C-Klasse",
      "C-Max",
      "Carens",
      "Carnival",
      "Ceed",
      "Cerato",
      "Challenger",
      "Charger",
      "Cherokee",
      "Chevrolet Avalanche 2007-2011",
      "Chevrolet Camaro",
      "Chevrolet Captiva",
      "Chevrolet Cobalt 2005-2010",
      "Chevrolet Colorado",
      "Chevrolet Cruze",
      "Chevrolet Epica",
      "Chevrolet Equinox 2004-2009",
      "Chevrolet Express 2007-2012",
      "Chevrolet HHR 2005-2011",
      "Chevrolet Impala 2006-2012",
      "Chevrolet Malibu",
      "Chevrolet Monte Carlo 2006-2007",
      "Chevrolet S10",
      "Chevrolet Silverado 1500 2500 3500 2007-2012",
      "Chevrolet Suburban 2007-2012",
      "Chevrolet Tahoe 2007-2012",
      "Chevrolet Trailblazer",
      "Chevrolet Traverse 2007-2012",
      "Chrysler 300C",
      "Chrysler Sebring",
      "Citroen Berlingo",
      "Citroen C3",
      "Citroen C-Crosser 2007-2012",
      "Citroen Jumper",
      "Civic 2006-2011",
      "CLA",
      "CLK",
      "CLS",
      "Cobalt",
      "Compass",
      "Connect",
      "Corsa",
      "Dacia Dokker ab 2012",
      "Dacia Duster ab 2012",
      "Dacia Lodgy ab 2012",
      "Dacia Logan ab 2012",
      "Dacia Sandero ab 2012",
      "Daihatsu Terios",
      "Denali",
      "Dodge Caliber",
      "Dodge Challenger SRT Hellcat",
      "Dodge Journey",
      "Ducato",
      "Duster",
      "E60",
      "E61",
      "E63",
      "E64",
      "E90",
      "E91",
      "E92",
      "E-Klasse",
      "Edge",
      "Enclave",
      "Equinox",
      "Escort",
      "Euro",
      "Express",
      "Fiat 500X",
      "Fiat Ducato",
      "Fiat Linea",
      "Fiat Panda",
      "Fiat Punto",
      "Fiesta",
      "Fiorino",
      "Fluence",
      "Focus",
      "Ford C-MAX",
      "Ford C-Max 2008-2010",
      "Ford Crown Victoria",
      "Ford Edge",
      "Ford Fiesta",
      "Ford Focus",
      "Ford Focus 2007-2010",
      "Ford Galaxy 2010-2011",
      "Ford Kuga",
      "Ford Mondeo 2000-2007",
      "Ford Mondeo MK4",
      "Ford Mustang 2010-2013",
      "Ford Ranger",
      "Ford Ranger (2011-2014)",
      "Ford S-Max",
      "Ford S-Max 2.0 TDCi",
      "Ford S-Max 2008-2011",
      "Ford Tourneo Transit",
      "Ford Transit",
      "Ford Transit Custom",
      "Forte",
      "Freemont",
      "Fusion",
      "G-Klasse",
      "Galaxy",
      "Giulietta",
      "GL",
      "GLA",
      "GLC",
      "GLE",
      "GLK",
      "GMC Acadia 2007-2012",
      "GMC Denali 2007-2012",
      "GMC Savana 2007-2012",
      "GMC Sierra 2007-2012",
      "GMC Yukon 2007-2012",
      "HHR",
      "Honda Accord 7",
      "Honda Accord 8",
      "Honda City",
      "Honda Civic",
      "Honda CR-V",
      "Honda CR-V 2007-2011",
      "Honda Jazz",
      "Hyundai i20",
      "Hyundai i30",
      "Hyundai Ix20",
      "Hyundai ix35",
      "Hyundai Santa Fe",
      "Hyundai Santa Fe (IX45)",
      "Hyundai Tucson",
      "i3",
      "i8",
      "i30",
      "Impala",
      "Insignia 2014-2015",
      "Isuzu D-Max MU-X",
      "IVECO Daily",
      "Jazz 2014-2020",
      "Jeep Caliber",
      "Jeep Cherokee",
      "Jeep Cherokee KK Liberty (2007-2012)",
      "Jeep Compass",
      "Jeep Compass 2.0TD",
      "Jeep Grand Cherokee",
      "Jeep Grand Cherokee 2014-2022",
      "Jeep Grand Cherokee (1998-2004)",
      "Jeep Renegade",
      "Jeep Wrangler",
      "Juke",
      "K3",
      "Kia Carens",
      "Kia Carnival",
      "Kia Morning",
      "Kia Optima (K5)",
      "Kia Picanto",
      "Kia Rio",
      "Kia Sorento",
      "Kia Soul",
      "Kia Sportage",
      "Kuga",
      "Lancia Voyager",
      "Lexus GS300",
      "Lexus GS350",
      "Lexus GS400",
      "Lexus GS430",
      "Lexus GS450H",
      "Lexus GS460",
      "Lexus RX 300",
      "Lexus RX 330",
      "Lotze",
      "M3",
      "M5",
      "Magentis",
      "MAN TGE 2017-2021",
      "Mazda 2",
      "Mazda 3",
      "Mazda 3 (2004-2009)",
      "Mazda 3 Axela",
      "Mazda 5",
      "Mazda 5 Premacy (2007-2013)",
      "Mazda 6",
      "Mazda 6 Ruiyi",
      "Mazda 6 Ultra",
      "Mazda 6 Ultra Ruiyi",
      "Mazda CX-5",
      "Mazda CX-7",
      "Mazda CX-9",
      "Mazda CX-9 (2007-2017)",
      "Megane 2/3",
      "Megane II",
      "Megane III",
      "Mercury Grand Marquis",
      "MINI",
      "Mitsubishi ASX",
      "Mitsubishi Grandis 2.0 2009",
      "Mitsubishi Lancer",
      "Mitsubishi Pajero",
      "Mitsubishi Pajero V97 2006-2016",
      "Mitsubishi SpaceStar",
      "ML",
      "Mondeo",
      "Monte Carlo",
      "Morning",
      "Navara",
      "Nemo",
      "Nissan Altima",
      "Nissan Dualis",
      "Nissan March/Micra",
      "Nissan Navara",
      "Nissan Note",
      "Nissan NV300",
      "Nissan Qashqai",
      "Nissan Qashqai (2009-2015)",
      "Nissan Qashqai AT (2013-2017)",
      "Nissan Qashqai J11 (2013-2017)",
      "Nissan Rogue",
      "Nissan X-Trail",
      "Nissan X-Trail J11 (2013-2017)",
      "Opel Adam",
      "Opel Antara",
      "Opel Antara (2005+)",
      "Opel Antara (ab 2005)",
      "Opel Astra H",
      "Opel Astra H (2004+)",
      "Opel Astra H (ab 2004)",
      "Opel Astra V16 (2010-2014)",
      "Opel Combo",
      "Opel Combo (2004+)",
      "Opel Combo (ab 2004)",
      "Opel Corsa",
      "Opel Corsa C",
      "Opel Corsa C (2004-2006)",
      "Opel Corsa D",
      "Opel Corsa D (2006+)",
      "Opel Corsa D (ab 2006)",
      "Opel Insignia",
      "Opel Insignia (2009-2013)",
      "Opel Meriva",
      "Opel Meriva (2004+)",
      "Opel Meriva (ab 2004)",
      "Opel Mocca",
      "Opel Mokka",
      "Opel Signum",
      "Opel Signum (2003+)",
      "Opel Signum (ab 2003)",
      "Opel Tigra TwinTop",
      "Opel Tigra TwinTop (2004+)",
      "Opel Tigra TwinTop (ab 2004)",
      "Opel Vectra C",
      "Opel Vectra C (2004+)",
      "Opel Vectra C (ab 2004)",
      "Opel Vivaro",
      "Opel Vivaro (2006+)",
      "Opel Vivaro (ab 2006)",
      "Opel Zafira",
      "Opel Zafira (2005+)",
      "Opel Zafira (ab 2005)",
      "Optima",
      "Pajero V93",
      "Pajero V97",
      "Pathfinder R51",
      "Peugeot 206 CC 2000-2016",
      "Peugeot 207",
      "Peugeot 307",
      "Peugeot 308",
      "Peugeot 308SW",
      "Peugeot 407",
      "Peugeot 408",
      "Peugeot 3008",
      "Peugeot 4007 2007-2012",
      "Peugeot 5008",
      "Peugeot Boxer",
      "Picanto",
      "Porsche 911 997",
      "Porsche 911 (997)",
      "Porsche Boxster 987",
      "Porsche Boxster (987)",
      "Porsche Cayenne",
      "Porsche Cayenne (2002-2010)",
      "Porsche Cayman 987",
      "Porsche Cayman (987C)",
      "Porsche Panamera",
      "Range Rover Evoque",
      "Range Rover Sport",
      "Range Rover Sport 2013-2017",
      "Renault Captur",
      "Renault Clio III",
      "Renault Koleos",
      "Renault Master",
      "Renault Megane",
      "Renault Trafic 3",
      "Rio",
      "Rond7",
      "Rondo",
      "S-Klasse",
      "S-Max",
      "Savana",
      "SEAT (generisch)",
      "SEAT Altea",
      "SEAT Altea (ab 05/2004)",
      "SEAT Altea XL",
      "SEAT Altea XL (ab 04/2007)",
      "Seat Exeo",
      "SEAT Exeo",
      "SEAT Exeo (Typ 3R)",
      "SEAT Ibiza",
      "SEAT Leon",
      "SEAT Leon (2012-2018)",
      "SEAT Leon (ab 09/2005)",
      "SEAT Toledo",
      "SEAT Toledo (ab 12/2004)",
      "Sedona",
      "Sierra",
      "Silverado 1500",
      "Silverado 2500",
      "Silverado 3500",
      "Skoda Fabia",
      "Skoda Fabia (2004-2009)",
      "Skoda Kodiaq",
      "Skoda Octavia",
      "Skoda Octavia (2004-2010)",
      "Skoda Octavia II/III",
      "Skoda Praktik",
      "Skoda Praktik (2004-2008)",
      "Skoda Roomster",
      "Skoda Roomster (2006-2010)",
      "Skoda Yeti",
      "Skoda Yeti (2009-2011)",
      "SL",
      "SLK",
      "Smart",
      "Sorento",
      "Soul",
      "Spectra",
      "Sportage",
      "Sprinter",
      "Star",
      "Subaru Forester",
      "Subaru Impreza",
      "Subaru Legacy",
      "Subaru Legacy Outback 2009-2014",
      "Subaru Outback",
      "Suburban",
      "Suzuki ALIVIO",
      "Suzuki Alto",
      "Suzuki Celerio",
      "Suzuki CIAZ",
      "Suzuki Cultus",
      "Suzuki Grand Vitara",
      "Suzuki Grand Vitara 2005-2013",
      "Suzuki Jimny",
      "Suzuki Jimny 2007-2013",
      "Suzuki S-Cross SX4 2014-2017",
      "Suzuki Swift",
      "Suzuki SX4",
      "Suzuki SX4 (2014-2017)",
      "Suzuki Vitara",
      "Suzuki Wagon R",
      "Tahoe",
      "Tivolan",
      "Tivoli",
      "Toyota Avalon",
      "Toyota Avensis",
      "Toyota Aygo",
      "Toyota Corolla",
      "Toyota Corolla Vios",
      "Toyota FJ Cruiser",
      "Toyota Fortuner",
      "Toyota Hilux",
      "Toyota Land Cruiser",
      "Toyota Prado",
      "Toyota Prado LC120",
      "Toyota Previa",
      "Toyota RAV4",
      "Toyota Rush",
      "Toyota Sequoia",
      "Toyota Sienna",
      "Toyota Terios",
      "Toyota Tundra",
      "Toyota Yaris",
      "Transit",
      "Traverse",
      "Universal",
      "V-Klasse",
      "Viano",
      "Vito",
      "Volvo C30",
      "Volvo C70",
      "Volvo S40",
      "Volvo S60",
      "Volvo S80",
      "Volvo V60",
      "Volvo XC90",
      "VW Amarok",
      "VW Caddy",
      "VW Caravelle 6 T6",
      "VW CC",
      "VW Crafter 2017-2021",
      "VW EOS",
      "VW Golf",
      "VW Golf5",
      "VW Golf6",
      "VW Golf 5",
      "VW Golf 5/6",
      "VW Golf 6",
      "VW Golf VII",
      "VW Golf VII/7",
      "VW Jetta",
      "VW Magotan",
      "VW Multivan T5",
      "VW New Beetle",
      "VW New Beetle 2",
      "VW Passat",
      "VW Passat 8",
      "VW Passat B6",
      "VW Passat B8",
      "VW Passat CC",
      "VW Passat/CC",
      "VW Polo",
      "VW Polo 5",
      "VW Polo V",
      "VW Polo V 6R",
      "VW Sagitar",
      "VW Scirocco",
      "VW Sharan",
      "VW T5 Multivan",
      "VW T5 Multivan Transporter (2008-2015)",
      "VW Tiguan",
      "VW Touareg",
      "VW Touareg (2003-2010)",
      "VW Touran",
      "VW Transporter (2014-2021)",
      "Wrangler",
      "X1",
      "X2",
      "X3",
      "X4",
      "X5",
      "X6",
      "X-Trek",
      "XC60",
      "Yukon",
      "Z4"
    ],
    "linked_metafields": [
      {
        "primary": "Audi",
        "secondary": "Audi A1"
      },
      {
        "primary": "Audi",
        "secondary": "Audi A3"
      },
      {
        "primary": "Audi",
        "secondary": "Audi A3 (8V)"
      },
      {
        "primary": "Audi",
        "secondary": "Audi A4"
      },
      {
        "primary": "Audi",
        "secondary": "Audi A4 (8E/8F/B7)"
      },
      {
        "primary": "Audi",
        "secondary": "Audi A4 (2000-2009)"
      },
      {
        "primary": "Audi",
        "secondary": "Audi A4 (2009-2016)"
      },
      {
        "primary": "Audi",
        "secondary": "Audi A4 (B7/8E/8F)"
      },
      {
        "primary": "Audi",
        "secondary": "Audi A4 (B8)"
      },
      {
        "primary": "Audi",
        "secondary": "Audi A4 B8"
      },
      {
        "primary": "Audi",
        "secondary": "Audi A4L"
      },
      {
        "primary": "Audi",
        "secondary": "Audi A4L (2009-2016)"
      },
      {
        "primary": "Audi",
        "secondary": "Audi A5"
      },
      {
        "primary": "Audi",
        "secondary": "Audi A5 (8T)"
      },
      {
        "primary": "Audi",
        "secondary": "Audi A5 (2009-2016)"
      },
      {
        "primary": "Audi",
        "secondary": "Audi A6"
      },
      {
        "primary": "Audi",
        "secondary": "Audi A6 (2005-2009)"
      },
      {
        "primary": "Audi",
        "secondary": "Audi A6 (C7)"
      },
      {
        "primary": "Audi",
        "secondary": "Audi A6 C6"
      },
      {
        "primary": "Audi",
        "secondary": "Audi A6L"
      },
      {
        "primary": "Audi",
        "secondary": "Audi A7"
      },
      {
        "primary": "Audi",
        "secondary": "Audi A7 (4G)"
      },
      {
        "primary": "Audi",
        "secondary": "Audi Q3"
      },
      {
        "primary": "Audi",
        "secondary": "Audi Q5 (2009-2016)"
      },
      {
        "primary": "Audi",
        "secondary": "Audi Q5 (Typ 8R)"
      },
      {
        "primary": "Audi",
        "secondary": "Audi Q5L"
      },
      {
        "primary": "Audi",
        "secondary": "Audi Q7"
      },
      {
        "primary": "Audi",
        "secondary": "Audi RS3"
      },
      {
        "primary": "Audi",
        "secondary": "Audi RS4 (8E/8F/B7)"
      },
      {
        "primary": "Audi",
        "secondary": "Audi RS4 (B7)"
      },
      {
        "primary": "Audi",
        "secondary": "Audi S3"
      },
      {
        "primary": "Audi",
        "secondary": "Audi S4"
      },
      {
        "primary": "Audi",
        "secondary": "Audi S4 (8E/8F/B7)"
      },
      {
        "primary": "Audi",
        "secondary": "Audi S4 (2000-2009)"
      },
      {
        "primary": "Audi",
        "secondary": "Audi S4 (B7)"
      },
      {
        "primary": "Audi",
        "secondary": "Audi S5"
      },
      {
        "primary": "Audi",
        "secondary": "Audi TT"
      },
      {
        "primary": "Audi",
        "secondary": "Audi TT (2006-2014)"
      },
      {
        "primary": "Audi",
        "secondary": "Audi TT (MK2)"
      },
      {
        "primary": "Audi",
        "secondary": "Seat Exeo"
      },
      {
        "primary": "Audi",
        "secondary": "SEAT Exeo (Typ 3R)"
      },
      {
        "primary": "BMW",
        "secondary": "1er"
      },
      {
        "primary": "BMW",
        "secondary": "2er"
      },
      {
        "primary": "BMW",
        "secondary": "3er"
      },
      {
        "primary": "BMW",
        "secondary": "4er"
      },
      {
        "primary": "BMW",
        "secondary": "5er"
      },
      {
        "primary": "BMW",
        "secondary": "6er"
      },
      {
        "primary": "BMW",
        "secondary": "7er"
      },
      {
        "primary": "BMW",
        "secondary": "E60"
      },
      {
        "primary": "BMW",
        "secondary": "E61"
      },
      {
        "primary": "BMW",
        "secondary": "E63"
      },
      {
        "primary": "BMW",
        "secondary": "E64"
      },
      {
        "primary": "BMW",
        "secondary": "E90"
      },
      {
        "primary": "BMW",
        "secondary": "E91"
      },
      {
        "primary": "BMW",
        "secondary": "E92"
      },
      {
        "primary": "BMW",
        "secondary": "i3"
      },
      {
        "primary": "BMW",
        "secondary": "i8"
      },
      {
        "primary": "BMW",
        "secondary": "M3"
      },
      {
        "primary": "BMW",
        "secondary": "M5"
      },
      {
        "primary": "BMW",
        "secondary": "MINI"
      },
      {
        "primary": "BMW",
        "secondary": "X1"
      },
      {
        "primary": "BMW",
        "secondary": "X2"
      },
      {
        "primary": "BMW",
        "secondary": "X3"
      },
      {
        "primary": "BMW",
        "secondary": "X4"
      },
      {
        "primary": "BMW",
        "secondary": "X5"
      },
      {
        "primary": "BMW",
        "secondary": "X6"
      },
      {
        "primary": "BMW",
        "secondary": "Z4"
      },
      {
        "primary": "Ford",
        "secondary": "C-Max"
      },
      {
        "primary": "Ford",
        "secondary": "Connect"
      },
      {
        "primary": "Ford",
        "secondary": "Edge"
      },
      {
        "primary": "Ford",
        "secondary": "Escort"
      },
      {
        "primary": "Ford",
        "secondary": "Fiesta"
      },
      {
        "primary": "Ford",
        "secondary": "Focus"
      },
      {
        "primary": "Ford",
        "secondary": "Ford C-MAX"
      },
      {
        "primary": "Ford",
        "secondary": "Ford C-Max 2008-2010"
      },
      {
        "primary": "Ford",
        "secondary": "Ford Crown Victoria"
      },
      {
        "primary": "Ford",
        "secondary": "Ford Edge"
      },
      {
        "primary": "Ford",
        "secondary": "Ford Fiesta"
      },
      {
        "primary": "Ford",
        "secondary": "Ford Focus"
      },
      {
        "primary": "Ford",
        "secondary": "Ford Focus 2007-2010"
      },
      {
        "primary": "Ford",
        "secondary": "Ford Galaxy 2010-2011"
      },
      {
        "primary": "Ford",
        "secondary": "Ford Kuga"
      },
      {
        "primary": "Ford",
        "secondary": "Ford Mondeo 2000-2007"
      },
      {
        "primary": "Ford",
        "secondary": "Ford Mondeo MK4"
      },
      {
        "primary": "Ford",
        "secondary": "Ford Mustang 2010-2013"
      },
      {
        "primary": "Ford",
        "secondary": "Ford Ranger"
      },
      {
        "primary": "Ford",
        "secondary": "Ford Ranger (2011-2014)"
      },
      {
        "primary": "Ford",
        "secondary": "Ford S-Max"
      },
      {
        "primary": "Ford",
        "secondary": "Ford S-Max 2.0 TDCi"
      },
      {
        "primary": "Ford",
        "secondary": "Ford S-Max 2008-2011"
      },
      {
        "primary": "Ford",
        "secondary": "Ford Tourneo Transit"
      },
      {
        "primary": "Ford",
        "secondary": "Ford Transit"
      },
      {
        "primary": "Ford",
        "secondary": "Ford Transit Custom"
      },
      {
        "primary": "Ford",
        "secondary": "Fusion"
      },
      {
        "primary": "Ford",
        "secondary": "Galaxy"
      },
      {
        "primary": "Ford",
        "secondary": "Kuga"
      },
      {
        "primary": "Ford",
        "secondary": "Mercury Grand Marquis"
      },
      {
        "primary": "Ford",
        "secondary": "Mondeo"
      },
      {
        "primary": "Ford",
        "secondary": "S-Max"
      },
      {
        "primary": "Ford",
        "secondary": "Transit"
      },
      {
        "primary": "Honda",
        "secondary": "Accord7 2003-2007 (Benzin)"
      },
      {
        "primary": "Honda",
        "secondary": "Civic 2006-2011"
      },
      {
        "primary": "Honda",
        "secondary": "Honda Accord 7"
      },
      {
        "primary": "Honda",
        "secondary": "Honda Accord 8"
      },
      {
        "primary": "Honda",
        "secondary": "Honda City"
      },
      {
        "primary": "Honda",
        "secondary": "Honda Civic"
      },
      {
        "primary": "Honda",
        "secondary": "Honda CR-V"
      },
      {
        "primary": "Honda",
        "secondary": "Honda CR-V 2007-2011"
      },
      {
        "primary": "Honda",
        "secondary": "Honda Jazz"
      },
      {
        "primary": "Honda",
        "secondary": "Jazz 2014-2020"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Carens"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Carnival"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Ceed"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Cerato"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Euro"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Forte"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Hyundai i20"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Hyundai i30"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Hyundai Ix20"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Hyundai ix35"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Hyundai Santa Fe"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Hyundai Santa Fe (IX45)"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Hyundai Tucson"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "i30"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "K3"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Kia Carens"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Kia Carnival"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Kia Morning"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Kia Optima (K5)"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Kia Picanto"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Kia Rio"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Kia Sorento"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Kia Soul"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Kia Sportage"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Lotze"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Magentis"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Morning"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Optima"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Picanto"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Rio"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Rond7"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Rondo"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Sedona"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Sorento"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Soul"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Spectra"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Sportage"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "Star"
      },
      {
        "primary": "Hyundai / Kia",
        "secondary": "X-Trek"
      },
      {
        "primary": "Mazda",
        "secondary": "Mazda 2"
      },
      {
        "primary": "Mazda",
        "secondary": "Mazda 3"
      },
      {
        "primary": "Mazda",
        "secondary": "Mazda 3 (2004-2009)"
      },
      {
        "primary": "Mazda",
        "secondary": "Mazda 3 Axela"
      },
      {
        "primary": "Mazda",
        "secondary": "Mazda 5"
      },
      {
        "primary": "Mazda",
        "secondary": "Mazda 5 Premacy (2007-2013)"
      },
      {
        "primary": "Mazda",
        "secondary": "Mazda 6"
      },
      {
        "primary": "Mazda",
        "secondary": "Mazda 6 Ruiyi"
      },
      {
        "primary": "Mazda",
        "secondary": "Mazda 6 Ultra"
      },
      {
        "primary": "Mazda",
        "secondary": "Mazda 6 Ultra Ruiyi"
      },
      {
        "primary": "Mazda",
        "secondary": "Mazda CX-5"
      },
      {
        "primary": "Mazda",
        "secondary": "Mazda CX-7"
      },
      {
        "primary": "Mazda",
        "secondary": "Mazda CX-9"
      },
      {
        "primary": "Mazda",
        "secondary": "Mazda CX-9 (2007-2017)"
      },
      {
        "primary": "Mercedes Benz",
        "secondary": "A-Klasse"
      },
      {
        "primary": "Mercedes Benz",
        "secondary": "B-Klasse"
      },
      {
        "primary": "Mercedes Benz",
        "secondary": "C-Klasse"
      },
      {
        "primary": "Mercedes Benz",
        "secondary": "CLA"
      },
      {
        "primary": "Mercedes Benz",
        "secondary": "CLK"
      },
      {
        "primary": "Mercedes Benz",
        "secondary": "CLS"
      },
      {
        "primary": "Mercedes Benz",
        "secondary": "E-Klasse"
      },
      {
        "primary": "Mercedes Benz",
        "secondary": "G-Klasse"
      },
      {
        "primary": "Mercedes Benz",
        "secondary": "GL"
      },
      {
        "primary": "Mercedes Benz",
        "secondary": "GLA"
      },
      {
        "primary": "Mercedes Benz",
        "secondary": "GLC"
      },
      {
        "primary": "Mercedes Benz",
        "secondary": "GLE"
      },
      {
        "primary": "Mercedes Benz",
        "secondary": "GLK"
      },
      {
        "primary": "Mercedes Benz",
        "secondary": "ML"
      },
      {
        "primary": "Mercedes Benz",
        "secondary": "S-Klasse"
      },
      {
        "primary": "Mercedes Benz",
        "secondary": "SL"
      },
      {
        "primary": "Mercedes Benz",
        "secondary": "SLK"
      },
      {
        "primary": "Mercedes Benz",
        "secondary": "Smart"
      },
      {
        "primary": "Mercedes Benz",
        "secondary": "Sprinter"
      },
      {
        "primary": "Mercedes Benz",
        "secondary": "V-Klasse"
      },
      {
        "primary": "Mercedes Benz",
        "secondary": "Viano"
      },
      {
        "primary": "Mercedes Benz",
        "secondary": "Vito"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "4007"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Bipper"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Buick Regal (2009-2013)"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "C4 / C4L"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Cherokee"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Chrysler 300C"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Chrysler Sebring"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Citroen Berlingo"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Citroen C3"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Citroen C-Crosser 2007-2012"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Citroen Jumper"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Compass"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Corsa"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Dodge Caliber"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Dodge Journey"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Ducato"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Fiat 500X"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Fiat Ducato"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Fiat Linea"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Fiat Panda"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Fiat Punto"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Fiorino"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Freemont"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Insignia 2014-2015"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Jeep Caliber"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Jeep Cherokee"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Jeep Cherokee KK Liberty (2007-2012)"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Jeep Compass"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Jeep Compass 2.0TD"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Jeep Grand Cherokee"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Jeep Grand Cherokee 2014-2022"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Jeep Grand Cherokee (1998-2004)"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Jeep Renegade"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Jeep Wrangler"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Nemo"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Adam"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Antara"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Antara (2005+)"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Antara (ab 2005)"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Astra H"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Astra H (2004+)"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Astra H (ab 2004)"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Astra V16 (2010-2014)"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Combo"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Combo (2004+)"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Combo (ab 2004)"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Corsa"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Corsa C"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Corsa C (2004-2006)"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Corsa D"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Corsa D (2006+)"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Corsa D (ab 2006)"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Insignia"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Insignia (2009-2013)"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Meriva"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Meriva (2004+)"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Meriva (ab 2004)"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Mocca"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Mokka"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Signum"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Signum (2003+)"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Signum (ab 2003)"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Tigra TwinTop"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Tigra TwinTop (2004+)"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Tigra TwinTop (ab 2004)"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Vectra C"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Vectra C (2004+)"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Vectra C (ab 2004)"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Vivaro"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Vivaro (2006+)"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Vivaro (ab 2006)"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Zafira"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Zafira (2005+)"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Opel Zafira (ab 2005)"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Peugeot 206 CC 2000-2016"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Peugeot 207"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Peugeot 307"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Peugeot 308"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Peugeot 308SW"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Peugeot 407"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Peugeot 408"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Peugeot 3008"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Peugeot 4007 2007-2012"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Peugeot 5008"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Peugeot Boxer"
      },
      {
        "primary": "Peugeot / Citroen / Opel / Fiat / Jeep",
        "secondary": "Wrangler"
      },
      {
        "primary": "Porsche",
        "secondary": "Porsche 911 997"
      },
      {
        "primary": "Porsche",
        "secondary": "Porsche 911 (997)"
      },
      {
        "primary": "Porsche",
        "secondary": "Porsche Boxster 987"
      },
      {
        "primary": "Porsche",
        "secondary": "Porsche Boxster (987)"
      },
      {
        "primary": "Porsche",
        "secondary": "Porsche Cayenne"
      },
      {
        "primary": "Porsche",
        "secondary": "Porsche Cayenne (2002-2010)"
      },
      {
        "primary": "Porsche",
        "secondary": "Porsche Cayman 987"
      },
      {
        "primary": "Porsche",
        "secondary": "Porsche Cayman (987C)"
      },
      {
        "primary": "Porsche",
        "secondary": "Porsche Panamera"
      },
      {
        "primary": "Renault / Nissan / Dacia",
        "secondary": "370Z Roadster"
      },
      {
        "primary": "Renault / Nissan / Dacia",
        "secondary": "Dacia Dokker ab 2012"
      },
      {
        "primary": "Renault / Nissan / Dacia",
        "secondary": "Dacia Duster ab 2012"
      },
      {
        "primary": "Renault / Nissan / Dacia",
        "secondary": "Dacia Lodgy ab 2012"
      },
      {
        "primary": "Renault / Nissan / Dacia",
        "secondary": "Dacia Logan ab 2012"
      },
      {
        "primary": "Renault / Nissan / Dacia",
        "secondary": "Dacia Sandero ab 2012"
      },
      {
        "primary": "Renault / Nissan / Dacia",
        "secondary": "Duster"
      },
      {
        "primary": "Renault / Nissan / Dacia",
        "secondary": "Fluence"
      },
      {
        "primary": "Renault / Nissan / Dacia",
        "secondary": "Juke"
      },
      {
        "primary": "Renault / Nissan / Dacia",
        "secondary": "Megane 2/3"
      },
      {
        "primary": "Renault / Nissan / Dacia",
        "secondary": "Megane II"
      },
      {
        "primary": "Renault / Nissan / Dacia",
        "secondary": "Megane III"
      },
      {
        "primary": "Renault / Nissan / Dacia",
        "secondary": "Navara"
      },
      {
        "primary": "Renault / Nissan / Dacia",
        "secondary": "Nissan Altima"
      },
      {
        "primary": "Renault / Nissan / Dacia",
        "secondary": "Nissan Dualis"
      },
      {
        "primary": "Renault / Nissan / Dacia",
        "secondary": "Nissan March/Micra"
      },
      {
        "primary": "Renault / Nissan / Dacia",
        "secondary": "Nissan Navara"
      },
      {
        "primary": "Renault / Nissan / Dacia",
        "secondary": "Nissan Note"
      },
      {
        "primary": "Renault / Nissan / Dacia",
        "secondary": "Nissan NV300"
      },
      {
        "primary": "Renault / Nissan / Dacia",
        "secondary": "Nissan Qashqai"
      },
      {
        "primary": "Renault / Nissan / Dacia",
        "secondary": "Nissan Qashqai (2009-2015)"
      },
      {
        "primary": "Renault / Nissan / Dacia",
        "secondary": "Nissan Qashqai AT (2013-2017)"
      },
      {
        "primary": "Renault / Nissan / Dacia",
        "secondary": "Nissan Qashqai J11 (2013-2017)"
      },
      {
        "primary": "Renault / Nissan / Dacia",
        "secondary": "Nissan Rogue"
      },
      {
        "primary": "Renault / Nissan / Dacia",
        "secondary": "Nissan X-Trail"
      },
      {
        "primary": "Renault / Nissan / Dacia",
        "secondary": "Nissan X-Trail J11 (2013-2017)"
      },
      {
        "primary": "Renault / Nissan / Dacia",
        "secondary": "Opel Vivaro"
      },
      {
        "primary": "Renault / Nissan / Dacia",
        "secondary": "Pathfinder R51"
      },
      {
        "primary": "Renault / Nissan / Dacia",
        "secondary": "Renault Captur"
      },
      {
        "primary": "Renault / Nissan / Dacia",
        "secondary": "Renault Clio III"
      },
      {
        "primary": "Renault / Nissan / Dacia",
        "secondary": "Renault Koleos"
      },
      {
        "primary": "Renault / Nissan / Dacia",
        "secondary": "Renault Master"
      },
      {
        "primary": "Renault / Nissan / Dacia",
        "secondary": "Renault Megane"
      },
      {
        "primary": "Renault / Nissan / Dacia",
        "secondary": "Renault Trafic 3"
      },
      {
        "primary": "Suzuki",
        "secondary": "Suzuki ALIVIO"
      },
      {
        "primary": "Suzuki",
        "secondary": "Suzuki Alto"
      },
      {
        "primary": "Suzuki",
        "secondary": "Suzuki Celerio"
      },
      {
        "primary": "Suzuki",
        "secondary": "Suzuki CIAZ"
      },
      {
        "primary": "Suzuki",
        "secondary": "Suzuki Cultus"
      },
      {
        "primary": "Suzuki",
        "secondary": "Suzuki Grand Vitara"
      },
      {
        "primary": "Suzuki",
        "secondary": "Suzuki Grand Vitara 2005-2013"
      },
      {
        "primary": "Suzuki",
        "secondary": "Suzuki Jimny"
      },
      {
        "primary": "Suzuki",
        "secondary": "Suzuki Jimny 2007-2013"
      },
      {
        "primary": "Suzuki",
        "secondary": "Suzuki S-Cross SX4 2014-2017"
      },
      {
        "primary": "Suzuki",
        "secondary": "Suzuki Swift"
      },
      {
        "primary": "Suzuki",
        "secondary": "Suzuki SX4"
      },
      {
        "primary": "Suzuki",
        "secondary": "Suzuki SX4 (2014-2017)"
      },
      {
        "primary": "Suzuki",
        "secondary": "Suzuki Vitara"
      },
      {
        "primary": "Suzuki",
        "secondary": "Suzuki Wagon R"
      },
      {
        "primary": "Toyota / Lexus",
        "secondary": "Lexus GS300"
      },
      {
        "primary": "Toyota / Lexus",
        "secondary": "Lexus GS350"
      },
      {
        "primary": "Toyota / Lexus",
        "secondary": "Lexus GS400"
      },
      {
        "primary": "Toyota / Lexus",
        "secondary": "Lexus GS430"
      },
      {
        "primary": "Toyota / Lexus",
        "secondary": "Lexus GS450H"
      },
      {
        "primary": "Toyota / Lexus",
        "secondary": "Lexus GS460"
      },
      {
        "primary": "Toyota / Lexus",
        "secondary": "Lexus RX 300"
      },
      {
        "primary": "Toyota / Lexus",
        "secondary": "Lexus RX 330"
      },
      {
        "primary": "Toyota / Lexus",
        "secondary": "Toyota Avalon"
      },
      {
        "primary": "Toyota / Lexus",
        "secondary": "Toyota Avensis"
      },
      {
        "primary": "Toyota / Lexus",
        "secondary": "Toyota Aygo"
      },
      {
        "primary": "Toyota / Lexus",
        "secondary": "Toyota Corolla"
      },
      {
        "primary": "Toyota / Lexus",
        "secondary": "Toyota Corolla Vios"
      },
      {
        "primary": "Toyota / Lexus",
        "secondary": "Toyota FJ Cruiser"
      },
      {
        "primary": "Toyota / Lexus",
        "secondary": "Toyota Fortuner"
      },
      {
        "primary": "Toyota / Lexus",
        "secondary": "Toyota Hilux"
      },
      {
        "primary": "Toyota / Lexus",
        "secondary": "Toyota Land Cruiser"
      },
      {
        "primary": "Toyota / Lexus",
        "secondary": "Toyota Prado"
      },
      {
        "primary": "Toyota / Lexus",
        "secondary": "Toyota Prado LC120"
      },
      {
        "primary": "Toyota / Lexus",
        "secondary": "Toyota Previa"
      },
      {
        "primary": "Toyota / Lexus",
        "secondary": "Toyota RAV4"
      },
      {
        "primary": "Toyota / Lexus",
        "secondary": "Toyota Sequoia"
      },
      {
        "primary": "Toyota / Lexus",
        "secondary": "Toyota Sienna"
      },
      {
        "primary": "Toyota / Lexus",
        "secondary": "Toyota Terios"
      },
      {
        "primary": "Toyota / Lexus",
        "secondary": "Toyota Tundra"
      },
      {
        "primary": "Toyota / Lexus",
        "secondary": "Toyota Yaris"
      },
      {
        "primary": "Universelle Autoradios",
        "secondary": "Universal"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "Audi A4/S4/RS4 8E/8F/B9/B7"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "SEAT (generisch)"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "SEAT Altea"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "SEAT Altea (ab 05/2004)"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "SEAT Altea XL"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "SEAT Altea XL (ab 04/2007)"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "SEAT Exeo"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "SEAT Ibiza"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "SEAT Leon"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "SEAT Leon (2012-2018)"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "SEAT Leon (ab 09/2005)"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "SEAT Toledo"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "SEAT Toledo (ab 12/2004)"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "Skoda Fabia"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "Skoda Fabia (2004-2009)"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "Skoda Kodiaq"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "Skoda Octavia"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "Skoda Octavia (2004-2010)"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "Skoda Octavia II/III"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "Skoda Praktik"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "Skoda Praktik (2004-2008)"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "Skoda Roomster"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "Skoda Roomster (2006-2010)"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "Skoda Yeti"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "Skoda Yeti (2009-2011)"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW Amarok"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW Caddy"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW Caravelle 6 T6"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW CC"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW EOS"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW Golf"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW Golf5"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW Golf6"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW Golf 5"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW Golf 5/6"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW Golf 6"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW Golf VII"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW Golf VII/7"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW Jetta"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW Magotan"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW Multivan T5"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW New Beetle"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW New Beetle 2"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW Passat"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW Passat 8"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW Passat B6"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW Passat B8"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW Passat CC"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW Passat/CC"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW Polo"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW Polo 5"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW Polo V"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW Polo V 6R"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW Sagitar"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW Scirocco"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW Sharan"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW T5 Multivan"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW T5 Multivan Transporter (2008-2015)"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW Tiguan"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW Touareg"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW Touareg (2003-2010)"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW Touran"
      },
      {
        "primary": "VW / Skoda / SEAT",
        "secondary": "VW Transporter (2014-2021)"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Acadia"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Alfa Romeo 159"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Alfa Romeo 159 Sportwagon"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Alfa Romeo Brera"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Alfa Romeo Giulietta"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Alfa Romeo Spider"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Avalanche"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Buick Enclave 2007-2012"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Challenger"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Charger"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Chevrolet Avalanche 2007-2011"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Chevrolet Camaro"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Chevrolet Captiva"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Chevrolet Cobalt 2005-2010"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Chevrolet Colorado"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Chevrolet Cruze"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Chevrolet Epica"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Chevrolet Equinox 2004-2009"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Chevrolet Express 2007-2012"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Chevrolet HHR 2005-2011"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Chevrolet Impala 2006-2012"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Chevrolet Malibu"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Chevrolet Monte Carlo 2006-2007"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Chevrolet S10"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Chevrolet Silverado 1500 2500 3500 2007-2012"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Chevrolet Suburban 2007-2012"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Chevrolet Tahoe 2007-2012"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Chevrolet Trailblazer"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Chevrolet Traverse 2007-2012"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Cobalt"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Daihatsu Terios"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Denali"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Dodge Challenger SRT Hellcat"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Enclave"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Equinox"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Express"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Fiat Panda"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Giulietta"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "GMC Acadia 2007-2012"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "GMC Denali 2007-2012"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "GMC Savana 2007-2012"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "GMC Sierra 2007-2012"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "GMC Yukon 2007-2012"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "HHR"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Impala"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Isuzu D-Max MU-X"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "IVECO Daily"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Lancia Voyager"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "MAN TGE 2017-2021"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Mitsubishi ASX"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Mitsubishi Grandis 2.0 2009"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Mitsubishi Lancer"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Mitsubishi Pajero"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Mitsubishi Pajero V97 2006-2016"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Mitsubishi SpaceStar"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Monte Carlo"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Pajero V93"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Pajero V97"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Range Rover Evoque"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Range Rover Sport"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Range Rover Sport 2013-2017"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Savana"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Sierra"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Silverado 1500"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Silverado 2500"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Silverado 3500"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Subaru Forester"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Subaru Impreza"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Subaru Legacy"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Subaru Legacy Outback 2009-2014"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Subaru Outback"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Suburban"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Tahoe"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Tivolan"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Tivoli"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Toyota Rush"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Traverse"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Volvo C30"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Volvo C70"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Volvo S40"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Volvo S60"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Volvo S80"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Volvo V60"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Volvo XC90"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "VW Crafter 2017-2021"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "XC60"
      },
      {
        "primary": "Weitere Marken",
        "secondary": "Yukon"
      }
    ]
  }
};
